import React, { createContext, useContext, useState } from "react";
import { motion } from "framer-motion";

const RippleContext = createContext();

export const RippleProvider = ({ children }) => {
  const [isExpanding, setIsExpanding] = useState(false);
  const [circlePosition, setCirclePosition] = useState({ x: 0, y: 0 });

  const triggerEffect = (event) => {
    const rect = event.target.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    setCirclePosition({ x: centerX, y: centerY });
    setIsExpanding(true);

    setTimeout(() => {
      setIsExpanding(false);
    }, 1500); // Wait for animation before closing
  };

  return (
    <RippleContext.Provider value={{ triggerEffect }}>
      {children}

      {/* Smooth Circular Expanding Effect */}
      {isExpanding && (
        <motion.div
          className="position-fixed"
          style={{
            backgroundColor: "#ffff", // Always black
            width: "100px",
            height: "100px",
            borderRadius: "50%",
            filter: "blur(80px)",
            top: `${circlePosition.y}px`,
            left: `${circlePosition.x}px`,
            transform: "translate(-50%, -50%)",
            zIndex: 9999,
          }}
          initial={{ scale: 0 }}
          animate={{ scale: 50 }} // Expands fully to cover screen
          transition={{ duration: 1.5, ease: "easeOut" }}
        />
      )}
    </RippleContext.Provider>
  );
};

export const useRippleEffect = () => useContext(RippleContext);
